import { render, staticRenderFns } from "./withdrawalcheck.vue?vue&type=template&id=51937122"
import script from "./withdrawalcheck.vue?vue&type=script&lang=js"
export * from "./withdrawalcheck.vue?vue&type=script&lang=js"
import style0 from "./withdrawalcheck.vue?vue&type=style&index=0&id=51937122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports